import React from 'react';
import { useEffect } from "react";
import { Helmet } from 'react-helmet';
import AboutDoctor from "./AboutDoctor.js";
import Banner from "./Banner.js";
import WhatWeDo from "./WhatWeDo.js";
// import Testimonials from "./Testimonials.js";
import PatientReviews from "./PatientReview.js";
import FollowYt from "./FollowYt.js";
import Faq from "./Faq.js";
import Blogs from "./Blogs.js";
import GetInTouch from "./GetInTouch.js";

function Home() {
  useEffect(() => {
    const metaTags = document.getElementsByTagName('meta');
    Array.from(metaTags).forEach((tag) => {
      console.log(tag);
    });
  }, []);
  return (
    <div>
      <Helmet>
      <title>Best ENT Specialist in Delhi | MedFirst ENT Centre</title>
      <meta name="description" content="Leading ENT specialist in Delhi offering best care for ear, nose, and throat issues. Visit MedFirst ENT Centre for expert treatment today!" />
      <meta name="keywords" content="ENT specialist Delhi,ear nose throat doctor,MedFirst ENT Centre,ENT clinic Delhi,best ENT care" />
      <link rel="canonical" href="https://entdelhi.com/" />
            <meta property="og:title" content="Open Graph Title" />
      <meta property="og:description" content="Open Graph Description for Facebook etc." />
      <meta name="robots" content="index, follow" />
      {/* You can add more meta tags as needed */}
    </Helmet>
      <main>
        <Banner />
        <AboutDoctor />
        <WhatWeDo />
        {/* <Testimonials /> */}
        <PatientReviews />
        <FollowYt />
        <Faq />
        <Blogs />
        <GetInTouch />
      </main>
    </div>
  );
}

export default Home;
